import { useState, MouseEvent } from "react";

// material-ui
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

// assets
import { Edit2, Logout } from "iconsax-react";

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  handleLogout: () => void;
  handleEditProfile: () => void;
  user: any;
}

const ProfileTab = ({ handleLogout, handleEditProfile, user }: Props) => {

  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleListItemClick = (
    event: MouseEvent<HTMLDivElement>,
    index: number
  ) => {
    setSelectedIndex(index);
  };

  return (
    <List
      component="nav"
      sx={{ p: 0, "& .MuiListItemIcon-root": { minWidth: 32 } }}
    >
      {user?.user_type !== 6 ? (
        <ListItemButton
          selected={selectedIndex === 1}
          onClick={(event: MouseEvent<HTMLDivElement>) =>
            handleListItemClick(event, 1)
          }
        >
          <ListItemIcon>
            <Edit2 variant="Bulk" size={18} />
          </ListItemIcon>
          <ListItemText primary="Settings" onClick={handleEditProfile} />
        </ListItemButton>
      ) : (
        ""
      )}
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <Logout variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
